import { connect } from 'react-redux'
import { sagaActions as rootSagaActions } from 'store/sagas'
import { documentSourcesSelector } from 'selectors/documentSources'
import DocumentSources from './DocumentSources'

export default connect(
  (state, props) => {
    return {
      areDocumentSourcesLoaded: state.kanbo.documentSources.isLoaded,
      areDocumentSourcesLoading: state.kanbo.documentSources.isLoading,
      documentSources: documentSourcesSelector(state, props)
    }
  },
  {
    fetchDocumentSources: rootSagaActions.fetchDocumentSources,
    fetchDocumentSourceDetails: rootSagaActions.fetchDocumentSourceDetails,
    fetchAllDocumentSourcesDetails: rootSagaActions.fetchAllDocumentSourcesDetails,
    requestRepairDocumentSource: rootSagaActions.requestRepairDocumentSource,
    requestRepairAllDocumentSources: rootSagaActions.requestRepairAllDocumentSources,
    requestRemoveDocumentSource: rootSagaActions.requestRemoveDocumentSource
  }
)(DocumentSources)

